// hooks/useAuth.js
import { useState, useEffect } from 'react';
import { getAccess } from '../../api';

let accessData = null;
let isLoading = false;
let subscribers = [];
let logO=null
let isowner=false

export const useAuth = () => {
  const [access, setAccess] = useState(accessData);
  const [loading, setLoading] = useState(true);
  const [isOwner,setIsOwner]=useState(false)
  const [logo,setLogo]=useState('')

  const fetchAccess = async () => {
    if (isLoading) return;
    
    if (accessData) {
      setAccess(accessData);
      setLoading(false);
      // setLogo(logO)
      setIsOwner(isowner)
      return;
    }

    isLoading = true;
    try {
      const data = await getAccess();
      console.log('dddd',data);
      
      accessData = data?.data;
      setAccess(accessData);
       setLogo(data?.logo)
      setIsOwner(data?.isOwner)
      subscribers.forEach(cb => cb(accessData));
    } catch (error) {
      console.error('Failed to fetch access, providing fallback permissions:', error);
      // Fallback permissions in case of connection or authorization issues in dev
      const fallbackData = {
        permissions: {
          iurm: {
            enabled: true,
            sections: {
              Overview: { view: true, create: true, edit: true, delete: true },
              Contacts: { view: true, create: true, edit: true, delete: true },
              Leads: { view: true, create: true, edit: true, delete: true },
              Accounts: { view: true, create: true, edit: true, delete: true },
              Tasks: { view: true, create: true, edit: true, delete: true },
              Campaigns: { view: true, create: true, edit: true, delete: true },
              Integration: { view: true, create: true, edit: true, delete: true }
            }
          }
        }
      };
      accessData = fallbackData;
      setAccess(fallbackData);
      setIsOwner(true);
    } finally {
      isLoading = false;
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAccess();
  }, []);

  return { access, loading ,logo,isOwner};
};

// Check module-level access
export const hasModuleAccess = (module, access = accessData) => {
  const permissions = access?.permissions || {};
  return permissions?.[module]?.enabled === true;
};

// Check section-level access (new)
export const hasSectionAccess = (module, section, permissionType = 'view', access = accessData) => {
  const permissions = access?.permissions || {};
  const modulePermissions = permissions?.[module];
  
  if (!modulePermissions?.enabled) return false;
  
  const sectionPermissions = modulePermissions?.sections?.[section];
  if (!sectionPermissions) return false;
  
  // Check specific permission type (view, create, edit, delete)
  return sectionPermissions[permissionType] === true;
};

// Check if user has ANY access to a section (view, create, edit, or delete)
export const hasAnySectionAccess = (module, section, access = accessData) => {
  const permissions = access?.permissions || {};
  const modulePermissions = permissions?.[module];
  
  if (!modulePermissions?.enabled) return false;
  
  const sectionPermissions = modulePermissions?.sections?.[section];
  if (!sectionPermissions) return false;
  
  return sectionPermissions.view === true || 
         sectionPermissions.create === true || 
         sectionPermissions.edit === true || 
         sectionPermissions.delete === true;
};